const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBorussiaDortmundLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 560,
    height: 560,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.5,
    style: {
      fill: "#fde100",
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 25.5,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.31 6.781 6.75 20.879h2.91l6.66-20.879h-4.07L27.5 20.72 23.47 6.781h-4.16zM8.875 17.06v20.6h6.465c5.24 0 7.89-6.34 4.25-10.25v-.04c0-.02.03-.03.03-.03 3.03-3.41 1.75-9.43-3.87-10.28H8.875zm26.755 0v20.6h6.5c5.23 0 7.88-6.34 4.25-10.25v-.04c0-.02.03-.03.03-.03 3.02-3.41 1.75-9.43-3.88-10.28h-6.9zm-22.97 3.85h3.18c2.07 0 2.49 3.96.13 4.59h-3.31v-4.59zm26.81 0h3.16c2.06 0 2.49 3.96.12 4.59h-3.28v-4.59zm-26.81 8.28h2.81c2.33 0 3.19 4.24.16 4.84h-2.97v-4.84zm26.81 0h2.78c2.33 0 3.19 4.24.16 4.84h-2.94v-4.84zm-16 8.9c-1.67 0-3.03 1.37-3.03 3.04v4.56c0 1.67 1.36 3.03 3.03 3.03h.06c1.67 0 3.03-1.36 3.03-3.03v-4.56c0-1.67-1.36-3.04-3.03-3.04h-.06zm8.03 0c-1.67 0-3.09 1.3-3.09 2.97v.75c0 1.67 1.52 3.02 3.09 3.07 0 0 .64-.01.97-.19l.03 1.03c0 .52-.42.98-.94.97-.42-.02-1-.23-1-.75 0 0 .1-.69-.4-.69h-1.75c-.02.17 0 .27 0 .5 0 1.58 1.35 2.97 3.18 2.97 1.73-.02 2.94-1.34 2.94-3.06v-4.57c0-1.67-1.3-3-2.97-3h-.06zm.03 2.16c.55 0 .97.42.97.94v.59c0 .52-.42.94-.94.94-.55 0-1-.42-1-.94v-.59c0-.52.45-.94.97-.94zm-8.06.03c.55 0 1 .42 1 .94v4.53c0 .52-.45.94-.97.94-.55 0-.97-.42-.97-.94v-4.53c0-.52.42-.94.94-.94z",
    style: {
      fill: "#000",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(.45 .45)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorussiaDortmundLogo);
export default __webpack_public_path__ + "static/media/Borussia_Dortmund_logo.154c9b292f9e592b08d2c840422d474a.svg";
export { ForwardRef as ReactComponent };